export default "__VITE_ASSET__DontscAt__"